type GenerateTextBoxWidthConfig = {
  widthPerCharacter?: number;
  minWidth?: number;
  maxWidth?: number;
};

export const generateTextBoxWidth = (title: string, config: GenerateTextBoxWidthConfig = {}) => {
  const { minWidth = 10, maxWidth, widthPerCharacter = 10 } = config;
  let width = minWidth + title.length * widthPerCharacter;

  if (maxWidth) {
    width = Math.min(minWidth + title.length * widthPerCharacter, maxWidth);
  }

  return width;
};
